import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as S from "./styles";
import { useToken } from '../../Components/TokenContext';
import { CarrinhoItens } from '../../Components/CarrinhoItens';

import promoLogo from '../../assets/img/promoLogo.png';

function Carrinho() {
    const { tokenData, checkToken } = useToken();
    const navigate = useNavigate();
    const [carrinho, setCarrinho] = useState([]);
    const [carrinhoPontos, setCarrinhoPontos] = useState();
    const [error, setError] = useState('');
    const baseUrl = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(true);
    const accessToken = localStorage.getItem('access_token');
    
    const [formLoading, setFormLoading] = useState(false);

    const fetchMyCarrinho = async () => {
        try {
            const response = await fetch(`${baseUrl}/carrinho`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            const data = await response.json();

            if (!response.ok) {
                setLoading(false);
                setError('Erro ao buscar os dados do carrinho.');
                return;
            }

            setCarrinho(data.produtos);
            setCarrinhoPontos(data.pontosCarrinho)

        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        fetchMyCarrinho();
    }, []);

    const handleFinalize = async () =>{
        const produtoIds = carrinho.map(produto => produto.id);
        setError('');
        setFormLoading(true);
      
        try {
            const response = await fetch(`${baseUrl}/finalizar/carrinho`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({ id: produtoIds })
            });

            const result = await response.json();

            if (!response.ok) {
                setError(result.message);
                setFormLoading(false);
                return;
            }

            setFormLoading(false);
            fetchMyCarrinho();
            checkToken();
            navigate('/carrinho', {
                state: {
                    message: { type: 'success', text: result.message },
                },
            });

        } catch (error) {
            setFormLoading(false);
            console.log(error.message);
        }
    }

    return (
        <S.Container>
            <section className="bg-primary">
                <div className="container max-w-large">
                    <img src={promoLogo} alt="Logo da promoção" className="mx-auto w-[160px] sm:w-[200px] 2xl:w-[250px] pt-24 sm:pt-40 2xl:pt-44 pb-16 sm:pb-20 2xl:pb-30 brightness-0 invert pointer-events-none" />

                    <h1 className="font-secondary-xt text-4xl 2xl:text-[45px] text-tertiary text-center font-semibold -mt-10 mb-6">Meu carrinho</h1>
                    <p className="text-lg text-center text-white mb-10">Confirme seu carrinho para troca dos pontos pelos seguintes prêmios:</p>
                    {loading ? (
                        <div className={`flex items-center justify-center transition-opacity duration-300`}>
                            <div className="mt-12 mb-12 h-12 w-12 animate-spin rounded-full border-4 border-solid border-tertiary border-t-transparent"></div>
                        </div>
                    ): (
                        <div className='carrinhoContent mt-12'>
                            {carrinho && carrinho.length > 0 ? (
                                carrinho.map((item, k) => (
                                    <div key={k} className='carrinhoContainer'>
                                        <CarrinhoItens data={item} fetchMyCarrinho={fetchMyCarrinho}/>
                                    </div>
                                ))
                            ): (
                                <p className="font-secondary-xt text-5xl 2xl:text-[60px] text-white text-center font-semibold opacity-30 italic pb-16">Seu carrinho está vazio.</p>
                            )}
                        </div>
                    )}
                    {
                        error && (
                            <div onClick={()=> setError('')} className="cursor-pointer mt-6 mb-6">
                                <div className="flex items-center justify-center w-full border-l-4 border-rose-500 bg-rose-100 px-7 py-4 shadow-md md:p-5">
                                    <div className="mr-5 flex h-9 w-full max-w-[36px] items-center justify-center rounded-lg bg-rose-500">
                                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path 
                                            d="M6.4917 7.65579L11.106 12.2645C11.2545 12.4128 11.4715 12.5 11.6738 12.5C11.8762 12.5 12.0931 12.4128 12.2416 12.2645C12.5621 11.9445 12.5623 11.4317 12.2423 11.1114C12.2422 11.1113 12.2422 11.1113 12.2422 11.1113C12.242 11.1111 12.2418 11.1109 12.2416 11.1107L7.64539 6.50351L12.2589 1.91221L12.2595 1.91158C12.5802 1.59132 12.5802 1.07805 12.2595 0.757793C11.9393 0.437994 11.4268 0.437869 11.1064 0.757418C11.1063 0.757543 11.1062 0.757668 11.106 0.757793L6.49234 5.34931L1.89459 0.740581L1.89396 0.739942C1.57364 0.420019 1.0608 0.420019 0.740487 0.739944C0.42005 1.05999 0.419837 1.57279 0.73985 1.89309L6.4917 7.65579ZM6.4917 7.65579L1.89459 12.2639L1.89395 12.2645C1.74546 12.4128 1.52854 12.5 1.32616 12.5C1.12377 12.5 0.906853 12.4128 0.758361 12.2645L1.1117 11.9108L0.758358 12.2645C0.437984 11.9445 0.437708 11.4319 0.757539 11.1116C0.757812 11.1113 0.758086 11.111 0.75836 11.1107L5.33864 6.50287L0.740487 1.89373L6.4917 7.65579Z" 
                                            fill="#ffffff" 
                                            stroke="#ffffff"
                                            />
                                        </svg>
                                    </div>

                                    <div className="w-full">
                                        <h5 className="text-left text-rose-800 text-opacity-80 font-medium">{error}</h5>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {carrinho && carrinho.length > 0 && loading == false && (

                    <button
                        className='block w-5/6 max-w-xs mx-auto mt-10 cursor-pointer rounded-lg border-2 border-tertiary bg-tertiary bg-opacity-0 p-3 text-lg md:text-xl text-white text-center font-semibold transition hover:bg-opacity-100 hover:text-primary' onClick={handleFinalize}
                        >
                        {!formLoading ? (
                            'Confirmar carrinho'
                        ) : (
                            <div role="status" className="flex justify-center items-center">
                                <svg aria-hidden="true" className="w-6 h-6 text-white text-opacity-60 animate-spin fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                                <span className="sr-only">Loading...</span>
                            </div>
                        )}
                    </button>
                    )}
                    {carrinhoPontos > 0 && (
                        <div className='valueCart py-12 font-secondary-xt text-lg text-white'>
                            <p>Total de pontos gastos: <strong>{carrinhoPontos} pts</strong> </p>
                        </div>
                    )}
                </div>
            </section>
        </S.Container>
    );
}

export default Carrinho;